export class FractalSDKError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FractalSDKError';
        Object.setPrototypeOf(this, FractalSDKError.prototype);
    }
    getUserFacingErrorMessage() {
        return 'Something went wrong: ' + this.message;
    }
}
export class FractalSDKNetworkError extends FractalSDKError {
    constructor(message) {
        super(message);
        this.name = 'FractalSDKNetworkError';
        Object.setPrototypeOf(this, FractalSDKNetworkError.prototype);
    }
    getUserFacingErrorMessage() {
        return 'A network error occurred';
    }
}
//# sourceMappingURL=base.js.map